import { Component, Input, OnInit } from '@angular/core';
import { ViewController } from 'ionic-angular';

@Component({
  selector: 'header-toolbar',
  templateUrl: 'header-toolbar.html'
})
export class HeaderToolbarComponent implements OnInit {
  @Input() title: string;
  @Input() showCalendar: boolean;
  @Input() showClose: boolean;
  @Input() showMenu: boolean;

  constructor(public viewCtrl: ViewController) {}

  ngOnInit() {}

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/shared/layout/header-toolbar.ts